'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SuggestDropdown } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/components/SuggestDropdown.js';
import { useMergeRef } from '#pplx/frontend/common/hooks/useMergeRef.js';
import { PplxtextInput } from '#pplx/frontend/components/form/ResizableInput/Input.js';
import { Wrapper } from '#pplx/frontend/components/form/ResizableInput/Wrapper.js';
import { framedComposerGeometry, isFramedAppearance } from '#pplx/frontend/composer-sdk/styles.js';
import { useMarkModuleTTVOnMount } from '#pplx/frontend/metrics/providers/PerformanceProviderShared.js';
import React, { useEffect, useRef } from 'react';
export const AskInputBase = React.memo(function AskInputBase({ value, suggestDropdownProps, ResizeableInputWrapperProps, ResizeableInputProps, leftAttributionComponents, rightAttributionComponents, syncUncontrolledOnce, }) {
    const onChange = ResizeableInputProps.onChange;
    const ref = ResizeableInputProps.ref;
    const valueRef = useRef(value);
    valueRef.current = value;
    const inputWrapperRef = useRef(null);
    const didSyncUncontrolledRef = useRef(false);
    const [inputRef, refCb] = useMergeRef(ref);
    const frameInsetPx = isFramedAppearance(ResizeableInputWrapperProps.appearance)
        ? framedComposerGeometry.insetPx
        : 0;
    useEffect(() => {
        // While loading and before React hydrate has completed, the input is uncontrolled
        // and not disabled. If someone enters input during this time, we should accept
        // the input and update the `value`.
        const input = inputRef.current;
        const inputValue = input?.value;
        if (inputValue &&
            inputValue !== valueRef.current &&
            (!syncUncontrolledOnce || !didSyncUncontrolledRef.current)) {
            onChange?.(inputValue, input.json);
        }
        if (syncUncontrolledOnce) {
            didSyncUncontrolledRef.current = true;
        }
    }, [inputRef, onChange, syncUncontrolledOnce]);
    useMarkModuleTTVOnMount('ask-input');
    return (_jsx(SuggestDropdown, { ...suggestDropdownProps, composerAppearance: isFramedAppearance(ResizeableInputWrapperProps.appearance) &&
            ResizeableInputWrapperProps.suggestionAttachment !== 'frame'
            ? ResizeableInputWrapperProps.appearance
            : undefined, 
        // The framed box bleeds past the trigger by its inset, so the trigger already matches the
        // editor's width; only tuck the dropdown under the frame's padding.
        offsetPx: -frameInsetPx, shouldEnableStacking: true, portalTarget: inputWrapperRef.current ?? undefined, value: value, children: _jsxs(Wrapper, { ...ResizeableInputWrapperProps, ref: inputWrapperRef, children: [_jsx(PplxtextInput, { ...ResizeableInputProps, ref: refCb }), leftAttributionComponents, rightAttributionComponents] }) }));
});
//# sourceMappingURL=AskInputBase.js.map